import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail, fetchDecorateList, fetchDecorateInsert, fetchFileList, fetchFileAdd, fetchFileDelete } from '@/api/PMS/houseDeliveryManage/decorationRegistration';
import { fetchHouseDetail } from '@/api/PMS/houseDeliveryManage/deliveryRegistration';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
export default {
  props: {
    showDialog: Boolean,
    keyValue: {
      type: Number,
      default: -1
    },
    needAddData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      uploadUrl: '',
      dialogImageUrl: '',
      downloadUrl: '',
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      rules: {
        upIdList: [{
          required: true,
          message: '请选择房间',
          trigger: 'change'
        }]
      },
      loading: false,
      dialogVisible: false,
      listObj: {},
      files: [],
      fileList: [],
      addList: [],
      delFileList: [],
      customerList: [],
      cascaderItem: [],
      houseList: [],
      list: [],
      dates: [],
      multipleSelection: [],
      childData: {},
      options: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    },
    needAddData: function needAddData(n, o) {
      var _this = this;

      if (n) {
        if (this.list.length === 0) {
          this.list = this.list.concat(n);

          if (this.keyValue > 0) {
            var list = this.list.map(function (item) {
              return {
                chargeStandardId: item.chargeStandardId
              };
            });
          }
        } else {
          n.forEach(function (item, i) {
            var isAdd = _this.list.every(function (val) {
              return val.chargeStandardId !== item.chargeStandardId;
            });

            if (isAdd) _this.list.push(item);
          });
        }
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
    this.init();
    this.loadMenuTree();
  },
  methods: {
    init: function init() {
      var _this2 = this;

      this.dates = [];
      this.list = [];
      this.files = [];
      this.fileList = [];
      this.addList = [];
      this.delFileList = [];
      this.customerList = [];
      this.$nextTick(function () {
        _this2.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDecorateList({
          decorateId: this.keyValue
        }).then(function (res) {
          if (res.data.code === 200 && res.data.data) {
            _this2.list = res.data.data;

            _this2.list.forEach(function (item) {
              item.amount = item.fixedAmount;
            });
          }
        });
        fetchFileList(queryData).then(function (res) {
          if (res.data.code === 200 && res.data.data) {
            _this2.files = res.data.data;

            _this2.files.forEach(function (item) {
              item.name = item.fileName;
              item.url = item.filePath;
            });
          }
        });
        fetchDetail(queryData).then(function (response) {
          if (response.data.code === 200) {
            _this2.childData = response.data.data;

            _this2.dates.push(_this2.childData.beginDate);

            _this2.dates.push(_this2.childData.expectEndDate);
          }
        });
      } else {
        this.childData = {};
      }
    },
    loadMenuTree: function loadMenuTree() {
      var _this3 = this;

      var treeQuery = {
        flag: 0
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this3.options = response.data.data;
      });
    },
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this4 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this4.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    // 检查是否选择下拉框是否选择正确的房间
    checkSelectHouse: function checkSelectHouse() {
      this.cascaderItem = [];
      this.getCascaderItem(this.childData.upIdList, this.options);

      if (this.cascaderItem[this.cascaderItem.length - 1].flag !== '211') {
        this.$message({
          message: '请选择正确的房间',
          type: 'error',
          duration: 3000
        });
        this.childData.upIdList = [];
        return;
      }

      var houseId = this.childData.upIdList[this.childData.upIdList.length - 1];
      this.$set(this.childData, 'houseId', houseId);
      this.handleSelectHouse(houseId);
    },
    handleSelectHouse: function handleSelectHouse(houseId) {
      var _this5 = this;

      this.$set(this.childData, 'customerName', '');
      this.$set(this.childData, 'customerId', '');
      this.$set(this.childData, 'houseArea', '');
      fetchHouseDetail({
        houseId: houseId
      }).then(function (res) {
        if (res.data.code === 200) {
          _this5.$set(_this5.childData, 'customerName', res.data.data.customerName);

          _this5.$set(_this5.childData, 'customerId', res.data.data.customerId);

          _this5.$set(_this5.childData, 'houseArea', res.data.data.houseUseArea);
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handCreate: function handCreate() {
      var _this6 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this6.dates !== null && _this6.dates.length > 0) {
            _this6.childData.beginDate = _this6.dates[0];
            _this6.childData.expectEndDate = _this6.dates[1];
          } else {
            _this6.Alert({
              alertType: 'error',
              message: '请选择装修时间'
            });

            return;
          }

          delete _this6.childData.dates;
          delete _this6.childData.upIdList;
          delete _this6.childData.customerName;

          if (_this6.list) {
            var changeDecorateBillVos = _this6.list.map(function (item) {
              return {
                chargeStandardId: item.chargeStandardId
              };
            });

            _this6.childData.changeDecorateBillVos = changeDecorateBillVos;
          } else {
            _this6.childData.changeDecorateBillVos = [];
          }

          if (_this6.keyValue > 0) {
            fetchFileAdd(_this6.addList);
            fetchFileDelete(_this6.delFileList);
            fetchUpdate(_this6.childData).then(function () {
              _this6.$emit('handCancle', true);

              _this6.Alert({
                alertType: 'update'
              });
            });
          } else {
            _this6.childData.changeDecorateFileVos = _this6.fileList;
            fetchCreate(_this6.childData).then(function () {
              _this6.keyValue = -1;

              _this6.$emit('handCancle', true);

              _this6.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this6.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handleAddCharge: function handleAddCharge() {
      if (this.childData.upIdList && this.childData.upIdList.length > 0) {
        var houseId = this.childData.upIdList[this.childData.upIdList.length - 1];
        this.$emit('addCharge', houseId);
      } else if (this.keyValue > 0) {
        this.$emit('addCharge', this.childData.houseId);
      } else if (this.keyValue < 0) {
        this.$message.error('请先选择房间');
      }
    },
    handleDeletes: function handleDeletes() {
      var chargeStandardIds = [];
      this.multipleSelection.forEach(function (row) {
        chargeStandardIds.push(row.chargeStandardId);
      });
      this.delete(chargeStandardIds);
    },
    delete: function _delete(chargeStandardIds) {
      var _this7 = this;

      if (chargeStandardIds.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          var _loop = function _loop(i) {
            chargeStandardIds.forEach(function (id) {
              if (_this7.list[i].chargeStandardId === id) {
                _this7.list.splice(i, 1);
              }

              _this7.Alert({
                alertType: 'delete'
              });
            });
          };

          for (var i = 0; i < _this7.list.length; i++) {
            _loop(i);
          }
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handBindingCancle: function handBindingCancle() {
      this.$emit('handCancle', 'binding');
    },
    // 上传图片成功时获取服务器图片URL
    handleSuccess: function handleSuccess(response, file) {
      if (response.code === 200) {
        this.addList.push({
          decorateId: this.keyValue,
          filePath: file.response.data[0].fileId,
          fileName: response.data[0].fileName,
          fileExt: this.judgeFileType(file.raw.type)
        });
        this.fileList.push({
          filePath: file.response.data[0].fileId,
          fileName: response.data[0].fileName,
          fileExt: this.judgeFileType(file.raw.type)
        });
      }
    },
    handleError: function handleError(err, file, fileList) {
      var res = JSON.parse(err.message);
      this.$message({
        message: res.message,
        type: 'error'
      });
    },
    handlePreview: function handlePreview(file) {
      if (file.response !== undefined) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.raw.type === 'image/png' || file.raw.type === 'image/jpeg' || file.raw.type === 'image/jpg') {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        if (file.fileExt === 2) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.url;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.url;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      }
    },
    beforeUpload: function beforeUpload(file) {
      var extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      extension = extension.toLowerCase();
      var isLt2M = file.size / 1024 / 1024 < 10;
      var fileFormatOK = extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'doc' || extension === 'docx' || extension === 'xls' || extension === 'xlsx' || extension === 'pdf';

      if (!fileFormatOK) {
        this.$message({
          message: '只支持上传 jpg/png/word/excel/pdf 格式文件!',
          type: 'error'
        });
        return false;
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'error'
        });
        return false;
      }
    },
    // 移除图片
    handleRemove: function handleRemove(file, fileList) {
      var _this8 = this;

      var currentUrl = 0; // 获取当前删除文件的url

      var currentFileName = ''; // 获取当前删除文件的文件名

      var currentFileType = ''; // 获取当前删除文件的文件类型

      if (file.response !== undefined) {
        // 文件是新增加的
        currentUrl = file.response.data[0].fileId;
        currentFileName = file.response.data[0].fileName;
        currentFileType = file.raw.type;
      } else {
        // 文件是旧数据
        currentUrl = file.url;
        currentFileName = file.name;
        currentFileType = file.type;
      }

      this.fileList.forEach(function (item, index) {
        if (currentUrl === item.url) {
          _this8.fileList.splice(index, 1);

          return;
        }
      });
      this.files.forEach(function (col, n) {
        if (currentUrl === col.url) {
          _this8.delFileList.push(col.fileId);

          return;
        }
      });
      this.addList.forEach(function (item, index) {
        if (item.filePath === currentUrl) {
          _this8.addList.splice(index, 1);
        }
      });
    },
    // 下载文件
    handleDownload: function handleDownload(url, name) {
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    },
    // 判断上传的文件类型，方便数据库保存
    judgeFileType: function judgeFileType(str) {
      if (str === 'image/png' || str === 'image/jpeg' || str === 'image/jpg') {
        return 2;
      } else {
        return 1;
      }
    }
  }
};